export const SALES_AND_MARKETING_CALENDLY_URL = 'https://calendly.com/pietra-studio/salesandmarketing';
export const ANALYTICS_CALENDLY = 'https://calendly.com/pietrastudio/analytics';
export const LAUREN_CALENDLY = { name: 'Lauren', url: 'https://calendly.com/pietrastudio/pietra-intro' };
export const PRINCE_CALENDLY = {
  name: 'Prince',
  url: 'https://calendly.com/prince-pietrastudio/pietra-inbound-calendar',
};
export const PRINCE_CALENDLY_30_MIN_DEMO = {
  name: 'Prince',
  url: 'https://calendly.com/prince-pietrastudio/pietra-30-minute-chat',
};
